module.exports = __webpack_public_path__ + "img/qtv-slides-3-new.9db6b930.png";